/**
 * Notification utility functions
 */
import axios from 'axios';

/**
 * Send a notification to a user
 * @param {number} userId - The ID of the user to receive the notification
 * @param {string} message - The notification message
 * @param {string} link - The link to navigate to when the notification is clicked
 * @param {number} senderId - The ID of the user sending the notification
 * @param {boolean} internalLink - Whether the link should open in the same tab (true) or a new tab (false)
 * @returns {Promise} - A promise that resolves when the notification is sent
 */
export async function sendNotification(userId, message, link, senderId, internalLink = true) {
  const notificationData = {
    userId: userId,
    message: message,
    link: link,
    internalLink: internalLink
  };

  if (senderId) {
    notificationData.senderId = senderId;
  }

  try {
    const response = await axios.post(window.ticketApi + 'notifications/send', notificationData);

    const notification = response.data;
    console.log('Notification sent:', notification);
    return notification;
  } catch (error) {
    console.error('Error sending notification:', error);
    throw error;
  }
}
